module.exports = __webpack_public_path__ + "static/media/Download.5354c57c.svg";